module.exports = __webpack_public_path__ + "static/media/gg.357e1e33.svg";